import React, { Component } from 'react';
import { Grid, Image, Segment } from 'semantic-ui-react';
import Address from './Address';
import ContactUs from './ContactUs';

export default class Footer extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="common-footer">
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column largeScreen={8} mobile={16} tablet={16}>
              <Address />
            </Grid.Column>
            <Grid.Column largeScreen={8} mobile={16} tablet={16}>
              <ContactUs />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Footer.js